import { render, staticRenderFns } from "./teamFitRefForm.vue?vue&type=template&id=32ec1c9a&scoped=true&"
import script from "./teamFitRefForm.vue?vue&type=script&lang=js&"
export * from "./teamFitRefForm.vue?vue&type=script&lang=js&"
import style0 from "./teamFitRefForm.vue?vue&type=style&index=0&id=32ec1c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec1c9a",
  null
  
)

export default component.exports